import { Icon, List, ListItem, Navbar, Page } from "framework7-react";

import { NavLeftBack } from "@/components/NavLeftBack";
import { NavRightEmpty } from "@/components/NavRightEmpty";
import { NavTitle } from "@/components/NavTitle";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { usePageReady } from "@/hooks/usePageReady";

export const AppSettingPage = createPage("AppSettingPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { getPageProps } = usePageReady(pageName);

  return (
    <Page
      data-component={pageName}
      {...getPageProps()}
    >
      <Navbar>
        <NavLeftBack />
        <NavTitle>アプリ設定</NavTitle>
        <NavRightEmpty />
      </Navbar>

      <List
        dividersIos
        inset
        mediaList
        strong
      >
        <ListItem
          chevronCenter
          link="/settings/app/categories/"
          title="カテゴリーの変更"
        >
          <Icon
            material="folder"
            slot="media"
          />
        </ListItem>

        <ListItem
          chevronCenter
          link="/settings/app/feelings/"
          title="気分の変更"
        >
          <Icon
            material="sentiment_satisfied"
            slot="media"
          />
        </ListItem>

        <ListItem
          chevronCenter
          link="#"
          title="テーマカラーの変更"
        >
          <Icon
            material="palette"
            slot="media"
          />
        </ListItem>

        <ListItem
          chevronCenter
          after="月曜"
          link="#"
          title="振り返り曜日"
        >
          <Icon
            material="event"
            slot="media"
          />
        </ListItem>
      </List>
    </Page>
  );
}
